import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-custom-cutoff": "",
  class: "flex flex-wrap items-end gap-4 rounded-[10px] border border-gray-200 bg-white px-[22px] py-5"
}
const _hoisted_2 = { class: "flex flex-wrap items-center gap-4" }

import { computed } from 'vue'

import SelectInput from '@/components/neue/SelectInput.vue'
import NumberStepper from '@/components/neue/wizard/NumberStepper.vue'
import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import {
  CLOSE_DAYS_MAX,
  CUTOFF_PRESETS,
  HOURS,
  ONCE_OPENS_OPTIONS,
  OPENS_OPTIONS,
  sectionCopy
} from '@/config/dropWizardSteps'


export default {
  __name: 'StepClose',
  setup(__props) {

const wizard = injectWizard()
const ordering = computed(() => wizard.data.ordering)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('closes', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, { label: "Ordering closes" }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CUTOFF_PRESETS), (preset) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: preset.value,
                compact: "",
                name: groupName,
                title: preset.title,
                subtitle: preset.subtitle,
                selected: ordering.value.cutoff === preset.value,
                onSelect: $event => (ordering.value.cutoff = preset.value)
              }, null, 8, ["name", "title", "subtitle", "selected", "onSelect"]))
            }), 128))
          ]),
          _: 1
        }),
        (ordering.value.cutoff === 'custom')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(NumberStepper, {
                "model-value": ordering.value.closesDaysBefore,
                name: "Days before production",
                min: 0,
                max: _unref(CLOSE_DAYS_MAX),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (ordering.value.closesDaysBefore = Math.min($event ?? 0, _unref(CLOSE_DAYS_MAX))))
              }, null, 8, ["model-value", "max"]),
              _createVNode(SelectInput, {
                modelValue: ordering.value.closesTime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((ordering.value.closesTime) = $event)),
                name: "At",
                options: _unref(HOURS)
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('opens', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createVNode(PillRadioGroup, {
          modelValue: ordering.value.opens,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((ordering.value.opens) = $event)),
          label: "Ordering opens",
          options: _unref(wizard).data.rhythm === 'once' ? _unref(ONCE_OPENS_OPTIONS) : _unref(OPENS_OPTIONS)
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('limit', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(PillRadioGroup, {
            "model-value": ordering.value.limitOn,
            label: "Order limit",
            options: [
          { value: false, name: 'No limit' },
          { value: true, name: 'Set a limit' }
        ],
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (ordering.value.limitOn = $event))
          }, null, 8, ["model-value"]),
          (ordering.value.limitOn)
            ? (_openBlock(), _createBlock(NumberStepper, {
                key: 0,
                modelValue: ordering.value.limit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((ordering.value.limit) = $event)),
                name: "Orders per date",
                min: 1,
                step: 5
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}